/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ErrorModel } from '../../models/error-model';

export interface RedirectToMySvgWithCustomerNumber$Params {

/**
 * 7-digit SVG customer number (e.g., 4101689)
 */
  customerNumber: string;
}

export function redirectToMySvgWithCustomerNumber(http: HttpClient, rootUrl: string, params: RedirectToMySvgWithCustomerNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<ErrorModel>> {
  const rb = new RequestBuilder(rootUrl, redirectToMySvgWithCustomerNumber.PATH, 'get');
  if (params) {
    rb.path('customerNumber', params.customerNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/problem+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ErrorModel>;
    })
  );
}

redirectToMySvgWithCustomerNumber.PATH = '/public/redirect/mysvg/{customerNumber}';
